import { render, staticRenderFns } from "./InvoiceDataFeed.vue?vue&type=template&id=6ae028e0&scoped=true&"
import script from "./InvoiceDataFeed.vue?vue&type=script&lang=ts&"
export * from "./InvoiceDataFeed.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceDataFeed.vue?vue&type=style&index=0&id=6ae028e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae028e0",
  null
  
)

export default component.exports